<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-09-18 11:20:54
 * @LastEditors: Chenhw2017 1272617071@qq.com
 * @LastEditTime: 2024-07-09 10:34:08
-->
<template>
	<span>
		<!-- 批量发货 -->
		<el-dialog title="批量发货" :visible.sync="visible" show-close>
			<div class="import-content mt-24">
				<el-steps :active="4" align-center>
					<el-step description="这是一段很长很长很长的描述性文字">
						<div slot="title" class="title">下载模板</div>
						<div slot="description">
							<p class="desc">待填内容包括订单号、快递公司与快递单号</p>
							<a :href="mainOrderUrl" target="_blank" class="link">下载批量导入模板</a>
						</div>
					</el-step>
					<el-step description="这是一段很长很长很长的描述性文字">
						<div slot="title" class="title">填写发货信息</div>
						<div slot="description">
							<p class="desc">在下载的表格中填写物流公司与物流单号</p>
							<a :href="companyXlsxUrl" target="_blank" class="link">下载快递公司列表</a>
						</div>
					</el-step>
					<el-step description="这是一段很长很长很长的描述性文字">
						<div slot="title" class="title">导入</div>
						<div slot="description">
							<p class="desc">将填写好的表格导入到平台</p>
						</div>
					</el-step>
					<el-step description="这是一段很长很长很长的描述性文字">
						<div slot="title" class="title">修改</div>
						<div slot="description">
							<p class="desc">导入失败的订单请修改后重新上传</p>
						</div>
					</el-step>
				</el-steps>
			</div>
			<span slot="footer">
				<upload-file accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" @upload="importOrder">
					<el-button type="primary">批量导入发货信息</el-button>
				</upload-file>
			</span>
		</el-dialog>
		<!-- 批量导入结果弹窗 -->
		<el-dialog title="批量导入结果" :visible.sync="resultDialogVisble" width="400px" show-close>
			<div class="result-content">
				<!-- 全部导入成功 -->
				<p v-if="importResult.status == 1">共计{{ importResult.success_num }}个样品订单，全部导入成功！</p>
				<!-- 无法识别表格内容 -->
				<div v-if="importResult.status == 2">
					<p>无法识别表格内容，请确认是否按照模板填写！</p>
					<p>如有疑问请联系客服！</p>
				</div>
				<!-- 部分导入失败 -->
				<div v-if="importResult.status == 3">
					<p>
						共计上传{{ importResult.count_all }}个样品订单，导入成功{{ importResult.success_num }}条， 导入失败<span
							:class="{ 'primary-color': importResult.fail_num != 0 }"
							>{{ importResult.fail_num }}</span
						>条，可以
						<el-button type="text" @click="downloadFailFile" :loading="loading">下载导入失败的订单</el-button>
						，查看失败原因，修改后重新上传
					</p>
				</div>
			</div>
			<span slot="footer">
				<el-button type="primary" v-if="importResult.status == 1" @click="resultDialogVisble = false">确认</el-button>
				<!-- 非导入全部成功展示重新导入发货单和联系客服 -->
				<div v-else class="flex flex-align-end flex-just-end">
					<el-tooltip placement="top">
						<!-- <img slot="content" src="https://cdn.chaoyongbushou.com/wx/20210720/vWaBaNQwIND390d0344da0796e0987db234fa3e367df.png" alt="" width="160" height="160">
                <a href="javascript:;" class="link">遇到困难？联系客服</a> -->
					</el-tooltip>
					<upload-file
						accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
						@upload="importOrder"
					>
						<el-button type="primary">重新导入发货单</el-button>
					</upload-file>
				</div>
			</span>
		</el-dialog>
	</span>
</template>

<script>
import { batchSend, batchFail, getCompanyXlsxUrl } from '@/api/cooperationProgress';
import UploadFile from '@/components/common/UploadFile';
export default {
	name: 'ExportOrder',
	components: {
		UploadFile,
	},
	data() {
		return {
			visible: false,
			resultDialogVisble: false,
			importResult: {
				status: '',
				success_num: '',
				fail_num: '',
			},
			loading: false,
			mainOrderUrl: '',
			companyXlsxUrl: '',
		};
	},
	methods: {
		async getCompanyXlsxUrl() {
			try {
				const {  batchSendXlsxUrl, companyXlsxUrl } = await getCompanyXlsxUrl();
				this.companyXlsxUrl = companyXlsxUrl;
				this.mainOrderUrl = batchSendXlsxUrl;
			} catch (error) {
				console.log(error);
			}
		},
		importInit(row) {
			this.getCompanyXlsxUrl();
			this.visible = true;
		},
		async importOrder(data) {
			try {
				const res = await batchSend(data);
				if (res?.code == 0) {
					this.importResult = {
						status: res?.data?.fail_num == 0 ? 1 : 3,
						...res.data,
					};
					// 全部成功或者部分成功之后刷新列表数据
					this.$emit('refreshList');
				} else {
					this.importResult = {
						status: 2,
					};
				}
				this.visible = false;
				this.resultDialogVisble = true;
			} catch (error) {
				console.log(error);
			}
		},
		async downloadFailFile() {
			try {
				this.loading = true;
				const { download_url } = await batchFail({ seller_token: CookiesTools.getToken(), batch_sn: this.importResult?.batch_sn });
				this.loading = false;
				window.open(download_url, '_blank');
			} catch (error) {
				if (error.code === -1) {
					this.$message.error(error.message);
				}
				this.loading = false;
			}
		},
	},
};
</script>
<style lang="less" scoped>
.import-content {
	.title {
		font-size: 14px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #323233;
	}
	.desc {
		font-size: 12px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #969799;
		line-height: 18px;
	}
	.link {
		font-size: 12px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #ee0a24;
		line-height: 18px;
	}
}
.result-content {
	.link {
		color: #1890ff;
	}
}
/deep/.el-dialog__footer .link {
	margin-right: 10px;
	font-size: 12px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #1890ff;
	line-height: 18px;
}
</style>
